import { GrowthBook, GrowthBookProvider } from "@growthbook/growthbook-react";
import jwt_decode from "jwt-decode";
import { FC, PropsWithChildren, useEffect, useMemo } from "react";

import newRelicErrorReport from "web/utils/system/essentials/newRelicErrorReport";
import isValidTokenAccess from "web/utils/system/essentials/isValidTokenAccess";
import BrowserPersistence from "web/utils/system/storage/storage/browserPersistence";
import storageNames from "web/constants/storageNames";

import growthBookConfig from "web/context/growthBookConfig";

const storage = new BrowserPersistence();

const GrowthBookFF: FC<PropsWithChildren> = ({ children }) => {
  const gb = useMemo(() => {
    return new GrowthBook(growthBookConfig);
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const authenticated = isValidTokenAccess();

        if (authenticated) {
          const accessToken = storage.getItem(storageNames.tokenAccess);
          if (accessToken) {
            const { MyB_SSO_UID, companyId, realm_access } = jwt_decode<{
              MyB_SSO_UID: string;
              companyId: string;
              realm_access: { roles: string[] };
            }>(accessToken);

            const hasHrToolsEarlyAccess = realm_access.roles.includes(
              "HR_TOOLS_EARLY_ACCESS"
            );

            await gb.init({ streaming: true });
            await gb.updateAttributes({
              companyId,
              employeeId: MyB_SSO_UID,
              hasHrToolsEarlyAccess,
            });
          }
        } else {
          await gb.init({ streaming: true });
        }
      } catch (error) {
        newRelicErrorReport(
          error,
          "web-app/web/context/GrowthBookFF.tsx - gb.init"
        );
        console.error("Failed to initialize GrowthBook:", error);
      }
    })();
  }, [gb]);

  return <GrowthBookProvider growthbook={gb}>{children}</GrowthBookProvider>;
};

export default GrowthBookFF;
